module.exports = __webpack_public_path__ + "img/red.f7fc3dfc.gif";